
<div class="main_wrapper" appRestrictRightClickandShortcut style="position:relative">
  <app-loader></app-loader>
  <router-outlet></router-outlet>
</div>


